import {
  SimpleForm,
  SimpleFormProps,
  TextInput,
  required,
  NumberInput,
  SelectInput,
  DateTimeInput,
  FunctionField,
  DateField,
} from 'react-admin';
import { statusChoices } from '.';

export default function VisitSchedulesForm(props: Partial<SimpleFormProps>) {
  return (
    <SimpleForm {...props} redirect="list">
      <TextInput
        fullWidth
        label="Nome/Instituição"
        source="name"
        validate={[required()]}
      />

      <TextInput
        fullWidth
        label="CPF/CNPJ"
        source="document"
        validate={[required()]}
      />

      <NumberInput 
        label="Número de pessoas"
        source="countParticipants"
        validate={[required()]}
      />

      <TextInput
        fullWidth
        label="Telefone/Whatsapp"
        source="phone"
        validate={[required()]}
      />

      <TextInput
        fullWidth
        label="CEP"
        source="postalCode"
        validate={[required()]}
      />

      <TextInput
        fullWidth
        label="Cidade"
        source="city"
        validate={[required()]}
      />

      <TextInput
        fullWidth
        label="Estado"
        source="state"
        validate={[required()]}
      />

      <TextInput
        fullWidth
        label="Endereço"
        source="address"
        validate={[required()]}
      />

      <TextInput
        fullWidth
        label="Bairro"
        source="neighborhood"
        validate={[required()]}
      />

      <FunctionField 
        label="Data(s) selecionada(s)" 
        render={item => {
          return(
            <ul>
              {item.dates.map((date, id) => {
                const record = { id, date }
                return (
                  <li key={`item-${id}`}>
                    <DateField 
                      locales="pt-BR" 
                      options={{ timeZone: 'America/Sao_Paulo' }} 
                      showTime 
                      record={record} 
                      source='date' 
                    />
                  </li>
                )
              })}
            </ul>
          )
        }} 
      />

      <SelectInput
        choices={statusChoices}
        label="Status"
        source="status"
      />

    </SimpleForm>
  );
}
